<template>
    <b-row>
        <b-col cols="12" class="d-flex justify-content-end my-1">
            <b-button variant="primary" @click="$bvModal.show('add-complaint-modal')">
                Add Complaint
            </b-button>
        </b-col>

        <b-col md="2" sm="4" class="my-1">
            <b-form-group class="mb-0">
                <label class="d-inline-block text-sm-left mr-50">Per page</label>
                <b-form-select id="perPageSelect" v-model="perPage"
                    :options="pageOptions.map(option => ({ text: option, value: option }))" size="sm" class="w-50" />

            </b-form-group>
        </b-col>
        <b-col md="10" class="my-1">
            <b-form-group label="Filter" label-cols-sm="8" label-align-sm="right" label-size="sm"
                label-for="filterInput" class="mb-0">
                <b-input-group size="sm">
                    <b-form-input id="filterInput" v-model="searchQuery" @input="onSearch" type="search"
                        placeholder="Type to Search" />
                    <b-input-group-append>
                        <b-button :disabled="!searchQuery" @click="searchQuery = ''">
                            Clear
                        </b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </b-col>
        <b-col cols="12">
            <!-- Status Tabs -->
            <b-tabs v-model="currentTab" class="mb-3">
                <b-tab title="All" active></b-tab>
                <b-tab v-for="option in statusOptions" :title="option.text" :key="option.value"></b-tab>
            </b-tabs>
        </b-col>



        <b-col cols="12">
            <b-table striped hover responsive :items="filteredOpportunitiesByTab" :fields="fields" :per-page="perPage"
                :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" v-if="!loading">

                <template #cell(dueDate)="data">
                    {{ formatDate(data.item.dueDate) }}
                </template>
                <template #cell(createdOn)="data">
                    {{ formatDate(data.item.createdOn) }}
                </template>
                <template #cell(status)="data">
                    <b-badge :variant="getBadgeVariant(data.item.status)">{{ beautifyStatus(data.item.status)
                        }}</b-badge>
                </template>
                <template #cell(feedbacks)="data">
                    {{ getLatestFeedbackTitle(data.item.feedbacks) }}
                </template>
                <template #cell(actions)="data">
                    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                        <template #button-content>
                            <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
                        </template>
                        <b-dropdown-item :to="viewComplaint(data.item.id)">
                            <feather-icon icon="EyeIcon" class="mr-50" />
                            <span>View</span>
                        </b-dropdown-item>
                        <!-- Use span to simulate a disabled dropdown item -->
                        <span class="dropdown-item" v-if="['Resolved', 'NotResolved'].includes(data.item.status)"
                            style="color: #6c757d; pointer-events: none;">
                            <feather-icon icon="RotateCcwIcon" class="mr-50" />
                            <span>Change Status</span>
                        </span>
                        <!-- Otherwise, provide the option to change status -->
                        <b-dropdown-item v-else @click="promptChangeStatus(data.item)">
                            <feather-icon icon="RotateCcwIcon" class="mr-50" />
                            <span>Change Status</span>
                        </b-dropdown-item>
                        <!-- <b-dropdown-item @click="deleteComplaint(data.item.id)">
                            <feather-icon icon="TrashIcon" class="mr-50" />
                            <span>Delete</span>
                        </b-dropdown-item> -->
                    </b-dropdown>
                </template>

            </b-table>
            <div class="d-flex justify-content-center mb-1">
                <b-spinner variant="success" label="Spinning" block v-if="loadingopp"
                    style="width: 3rem; height: 3rem"></b-spinner>
            </div>
            <b-col cols="12">
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="center" size="sm"
                    class="my-0"></b-pagination>
            </b-col>
        </b-col>

        <!-- Modal for Status Change -->
        <b-modal id="change-status-modal" title="Change Complaint Status" @ok="changeStatus">
            <b-form-group label="Select New Status:" label-for="status-select">
                <b-form-select id="status-select" v-model="selectedStatus" :options="statusOptions"></b-form-select>
            </b-form-group>
            <template #modal-footer="{ ok, cancel }">
                <b-button @click="cancel" variant="secondary">Cancel</b-button>
                <b-button @click="ok" :disabled="isStatusChangeDisabled" variant="primary">Change Status</b-button>
            </template>
        </b-modal>

        <!-- Modal for add -->
        <b-modal id="add-complaint-modal" title="Add Complaints" @ok.prevent="onSubmit" @hidden="resetForm">
            <b-row>
                <b-col cols="12" class="mx-auto">
                    <b-card title="Add Complaint" class="mb-3">
                        <validation-observer ref="AddForm" #default="{ invalid }">
                            <b-form @submit.prevent="onSubmit">
                                <b-form-group label="Customer:" label-for="customer">
                                    <validation-provider #default="{ errors }" name="Customer" vid="Customer"
                                        rules="required">
                                        <b-form-select v-model="form.leadClientId" :options="optionsCustomer" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Assigned To:" label-for="Assigned">
                                    <validation-provider #default="{ errors }" name="Assigned To" vid="Assigned To"
                                        rules="required">
                                        <b-form-select v-model="form.salespersonId" :options="optionsSalesPerson" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Feedback Title:" label-for="Title">
                                    <validation-provider #default="{ errors }" name="Feedback Title"
                                        vid="Feedback Title" rules="required">
                                        <b-form-input id="Title" type="text" v-model="form.feedback.title" required
                                            placeholder="Enter Feedback Title"></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Feedback Description:" label-for="Description">
                                    <validation-provider #default="{ errors }" name="Feedback Description"
                                        vid="Feedback Description" rules="required">
                                        <b-form-textarea id="textarea-default" placeholder="Description" rows="3"
                                            v-model="form.feedback.description" required />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Status:" label-for="status-select">
                                    <validation-provider #default="{ errors }" name="Status" vid="Status"
                                        rules="required">
                                        <b-form-select id="status-select" v-model="form.status" :options="statusOptions"
                                            required></b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Priority:" label-for="priority-select">
                                    <validation-provider #default="{ errors }" name="Priority" vid="Priority"
                                        rules="required">
                                        <b-form-select id="priority-select" v-model="form.rating"
                                            :options="priorityOptions" required></b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Open Date" label-for="creationDate">
                                            <b-form-datepicker id="creationDate" class="mb-1" v-model="creationDate"
                                                 />
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="12">
                                        <b-form-group label="Due Date" label-for="dueDate">
                                            <validation-provider #default="{ errors }" name="Due Date" vid="Due Date"
                                                rules="required">
                                                <b-form-datepicker id="dueDate" v-model="form.dueDate" required
                                                    placeholder="Select a Due Date">
                                                    <small class="text-danger">{{ errors[0] }}</small>
                                                </b-form-datepicker>
                                            </validation-provider>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </validation-observer>
                    </b-card>
                </b-col>
            </b-row>
            <template #modal-footer="{ ok }">
                <b-button variant="primary" @click="onSubmit" :disabled="submitting">
                    <b-spinner small v-if="submitting"></b-spinner>
                    {{ submitting ? 'Adding...' : 'Add' }}
                </b-button>
            </template>
        </b-modal>

        <b-modal id="edit-complaint-modal" title="Edit Opportunity" @ok.prevent="updateOpportunity">
            <b-row>
                <b-col cols="12" class="mx-auto">
                    <b-card title="Edit Opportunity" class="mb-3">
                        <validation-observer ref="EditForm" #default="{ invalid }">

                            <b-form @submit.prevent="updateOpportunity">

                                <b-form-group label="Customer/Lead:" label-for="customer-lead">
                                    <validation-provider #default="{ errors }" name="Customer/Lead" vid="Customer/Lead"
                                        rules="required">
                                        <b-form-select v-model="editFormData.leadClientId" :options="optionsCustomer" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group label="Opportunity Name:" label-for="name">
                                    <validation-provider #default="{ errors }" name="Opportunity Name"
                                        vid="Opportunity Name" rules="required">
                                        <b-form-input id="name" type="text" v-model="editFormData.name" required
                                            placeholder="Enter Opportunity Name"></b-form-input>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Status:" label-for="status-select">
                                    <validation-provider #default="{ errors }" name="Status" vid="Status"
                                        rules="required">
                                        <b-form-select id="status-select" v-model="editFormData.status"
                                            :options="statusOptions" required></b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <b-form-group label="Priority:" label-for="priority-select">
                                    <validation-provider #default="{ errors }" name="Priority" vid="Priority"
                                        rules="required">
                                        <b-form-select id="priority-select" v-model="editFormData.priority"
                                            :options="statusOptions" required></b-form-select>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group label="Expected Close Date:" label-for="expected-close-date">
                                    <b-form-datepicker id="expected-close-date" v-model="editFormData.expectedCloseDate"
                                        required placeholder="Select a date">
                                    </b-form-datepicker>
                                </b-form-group>
                                <b-form-group label="Description:" label-for="Description">
                                    <b-form-textarea id="textarea-default" placeholder="Description" rows="3"
                                        v-model="editFormData.description" required />
                                </b-form-group>
                            </b-form>
                        </validation-observer>
                    </b-card>
                </b-col>
            </b-row>
            <template #modal-footer="{ ok }">
                <b-button variant="primary" @click="updateOpportunity" :disabled="submitting">
                    <b-spinner small v-if="submitting"></b-spinner>
                    {{ submitting ? 'Editing...' : 'Edit' }}
                </b-button>
            </template>
        </b-modal>
    </b-row>
</template>

<script>
import Ripple from "vue-ripple-directive";
import {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BAlert,
    BCol,
    BFormGroup,
    BFormSelect,
    BTab,
    BTabs,
    BContainer,
    BPagination,
    BInputGroup,
    BFormInput,
    BForm,
    BFormDatepicker,
    BInputGroupAppend,
    VBModal,
    BButton,
    BSpinner,
    BModal,
    BDropdown,
    BFormTextarea,
    BDropdownItem,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
export default {
    components: {
        BTable,
        BAvatar,
        BForm,
        BTab,
        BTabs,
        BModal,
        BBadge,
        BRow,
        BContainer,
        BCol,
        BFormGroup,
        BFormSelect,
        BPagination,
        BInputGroup,
        VBModal,
        BFormInput,
        BFormDatepicker,
        BFormTextarea,
        BInputGroupAppend,
        BButton,
        BSpinner,
        BAlert,
        BDropdown,
        BDropdownItem,
        ValidationProvider,
        ValidationObserver,
    },
    directives: {
        "b-modal": VBModal,
        Ripple,
    },
    data() {
        return {
            formState: {},
            optionsSalesPerson: [],
            selectedStatus: null,
            loading: false,
            changingOpportunity: null,
            showModal: false,
            currentTab: 'All',
            searchQuery: '',
            pageOptions: [3, 5, 10],
            perPage: 5,
            creationDate: new Date(),
            fields: [
                { key: "complaintReference", sortable: true, label: "Complaint ID" },
                { key: "leadClientName", sortable: true, label: "Customer" },
                { key: "salesPersonName", sortable: true, label: "Assigned To" },
                { key: "status", sortable: true },
                { key: "feedbacks", sortable: true, label: "Latest Feedback" },
                { key: "rating", sortable: true,  label:"Priority" },
                { key: "createdOn", label: "Open Date", sortable: true },
                { key: "dueDate", sortable: true },
                { key: "actions" },
            ],
            currentPage: 1,
            perPage: 5,
            form: {
                complaintReference: null,
                salespersonId: null,
                leadClientId: null,
                dueDate: "",
                status: "",
                rating: null,
                feedback: {
                    complaintId: null,
                    title: "",
                    description: ""
                }
            },
            editFormData: {
                name: "",
                leadClientId: null,
                status: "",
                estimateValue: null,
                expectedCloseDate: "",
                description: "",
            },

            statusOptions: [
                { value: 'Open', text: "Open" },
                { value: 'Resolved', text: "Resolved" },
                { value: 'NotResolved', text: "Not Resolved" },
            ],

            priorityOptions: [
                { value: 'Low', text: "Low" },
                { value: 'Medium', text: "Medium" },
                { value: 'High', text: "High" },
            ],

            sortBy: '',
            sortDesc: false,
            optionsCustomer: [],

            submitting: false,
        };
    },

    computed: {
        ...mapGetters("complaintModule", {
            complaint: "complaints",
            loadingopp: "loading",
        }),

        ...mapGetters("customerModule", {
            CustomerList: "customers",
            loadingCustomer: "loading",
        }),


        ...mapGetters("salesPersonModule", {
            SalesPersonList: "salesperson",
            loading: "loading",
        }),
        rows() {
            return this.filteredOpportunities.length;
        },
        filteredOpportunities() {
            if (!this.searchQuery) {
                return this.complaint;
            }
            return this.complaint.filter((complaint) => {
                return Object.keys(complaint).some((key) => {
                    return String(complaint[key]).toLowerCase().includes(this.searchQuery.toLowerCase());
                });
            });
        },
        currentStatus() {
            const statusMapping = {
                0: 'All', // Representing all opportunities
                1: 'Open',
                2: 'Resolved',
                3: 'NotResolved',
            };

            return statusMapping[this.currentTab];
        },

        filteredOpportunitiesByTab() {
            // Use the newly created currentStatus computed property for filtering
            if (this.currentStatus === 'All') {
                return this.filteredOpportunities;
            }
            return this.filteredOpportunities.filter(
                (complaint) => complaint.status === this.currentStatus
            );
        },

        isStatusChangeDisabled() {
            if (!this.changingOpportunity || !this.selectedStatus) return true;
            // Disable the change if the current status is Resolved or NotResolved
            const disabledStatuses = ['Resolved', 'NotResolved'];
            if (disabledStatuses.includes(this.changingOpportunity.status)) {
                return true;
            }
            // Optionally, you can also disable changing to the same status
            if (this.changingOpportunity.status === this.selectedStatus) {
                return true;
            }
            return false;
        },
    },



    methods: {
        ...mapActions("complaintModule", ["getComplaintsListAction", "removeComplaintsAction", "updateComplaintStatusAction", "addComplaintsAction"]),
        ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
        ...mapActions("customerModule", ["getCustomersListAction"]),


        beautifyStatus(status) {
            return status
                .split(/(?=[A-Z])/)
                .join(' ')
                .trim();
        },

        formatDate(dateString) {
            if (!dateString) return ' - ';
            const date = new Date(dateString);
            const options = { year: 'numeric', month: 'long', day: 'numeric' };
            return date.toLocaleDateString(undefined, options);
        },
        formatAmount(value) {
            if (value == null) return ' - '; // Check for null or undefined
            return value.toFixed(2);
        },
        resetForm() {
            this.form = {
                complaintReference: null,
                salespersonId: null,
                leadClientId: null,
                dueDate: "",
                status: "",
                rating: null,
                feedback: {
                    complaintId: null,
                    title: "",
                    description: ""
                }
            };
        },

        getLatestFeedbackTitle(feedbacks) {
            if (!feedbacks || feedbacks.length === 0) return 'No Feedback';
            const latestFeedback = feedbacks[feedbacks.length - 1];
            return latestFeedback.title || 'No Title';
        },

        getBadgeVariant(status) {
            const statusVariantMapping = {
                'Open': 'info',
                'Resolved': 'success',
                'NotResolved': 'danger'
            };
            return statusVariantMapping[status] || 'secondary';
        },
        prepareEditOpportunity(item) {
            this.editFormData = {
                id: item.id,
                name: item.name,
                leadClientId: item.leadClientID,
                status: item.status,
                estimateValue: item.estimateValue.toString(),
                expectedCloseDate: item.expectedCloseDate,
                description: item.description,
            };

            this.$bvModal.show('edit-complaint-modal');
        },

        viewComplaint(id) {
            return "/complaint/view/" + id;
        },


        promptChangeStatus(complaint) {
            this.changingOpportunity = complaint;
            this.selectedStatus = complaint.status;
            this.$bvModal.show("change-status-modal");
        },

        async changeStatus() {
            if (!this.changingOpportunity || !this.selectedStatus) {
                this.error('Please select a status.');
                return;
            }

            const result = await this.$swal({
                title: 'Are you sure?',
                text: 'You are about to change the status of this complaint.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, change it!',
                cancelButtonText: 'No, keep it',
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false
            });

            if (result.isConfirmed) {
                this.$swal({
                    title: 'Updating Status...',
                    text: 'Please wait while the status is being updated...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    const payload = {
                        id: this.changingOpportunity.id,
                        status: this.selectedStatus
                    };

                    await this.updateComplaintStatusAction(payload)

                    this.$swal.hideLoading();
                    this.success('Status updated successfully!');
                } catch (error) {
                    this.$swal.hideLoading();
                    console.log(error)
                    this.error('There was a problem updating the status. Please try again.');
                } finally {
                    this.$bvModal.hide('change-status-modal');
                    await this.getComplaintsListAction();
                }
            }
        },
        isStatusChangeAllowed(currentStatus, newStatus) {
            const allowedTransitions = {
                New: ["In Progress", "Closed Lost"],
                "In Progress": ["New", "Closed Lost", "Closed Won"],
            };
            return allowedTransitions[currentStatus]?.includes(newStatus) ?? false;
        },

        async deleteComplaint(complaintId) {
            const result = await this.$swal({
                title: 'Are you sure?',
                text: 'You will not be able to recover this complaint!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, keep it',
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false
            });

            if (result.isConfirmed) {
                this.$swal({
                    title: 'Deleting...',
                    text: 'Please wait while the complaint is being deleted...',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                try {
                    await this.removeComplaintsAction(complaintId);
                    this.$swal.hideLoading();
                    this.success("Complaint deleted successfully");
                } catch (error) {
                    this.$swal.hideLoading();
                    this.error("There was a problem deleting the complaint. Please try again.");
                } finally {
                    this.$swal.close();
                    await this.getComplaintsListAction();
                }
            }
        },

        // Helper methods
        success(message) {
            this.$swal({
                title: "Success!",
                text: message,
                icon: "success",
                customClass: {
                    confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
            });
        },
        error(message) {
            this.$swal({
                title: 'Error!',
                text: message,
                icon: 'error',
                customClass: {
                    confirmButton: "btn btn-danger",
                },
                buttonsStyling: false,
            });
        },

        /////Edit
        async updateOpportunity() {
            this.submitting = true;
            const isValid = await this.$refs.AddForm.validate();
            if (isValid) {
                try {
                    const payloadEdit = {
                        ...this.editFormData,
                        estimateValue: parseFloat(this.editFormData.estimateValue),
                    };
                    await this.updateOpportuntiesAction({ id: this.editFormData.id, payload: payloadEdit });
                    this.success('Opportunity updated successfully!');
                } catch (error) {
                    console.error("Error updating complaint:", error);
                    this.error("There was an error updating the complaint. Please try again.");
                } finally {
                    this.submitting = false;
                    this.$bvModal.hide('edit-complaint-modal');
                    await this.getComplaintsListAction();
                }
            }
        },


        /////Add
        async onSubmit() {
            this.submitting = true;
            const isValid = await this.$refs.AddForm.validate();
            if (isValid) {
                try {
                    const payload = {
                        ...this.form,
                    };
                    await this.addComplaintsAction(payload);
                    this.success('Complaint added successfully!');
                } catch (error) {
                    this.error("There was an error adding the Complaint, please try again later");
                } finally {
                    this.submitting = false;
                    this.$bvModal.hide("add-complaint-modal");
                    await this.getComplaintsListAction();
                    this.resetForm();
                }
            } else {
                this.submitting = false;
            }
        }


    },

    async mounted() {
        await this.getComplaintsListAction()
            .then((response) => {
            })
            .catch((response) => {
                console.log(response);
            });
        await this.getCustomersListAction().then(() => {
            this.CustomerList.map((v, i) =>
                this.optionsCustomer.push({
                    value: v.id,
                    text: `${v.otherName} ${v.surname ?? ''}`,
                    item: v,
                })
            );
        });
        await this.getSalesPersonListAction().then(() => {
            this.SalesPersonList.map((v, i) =>
                this.optionsSalesPerson.push({
                    value: v.id,
                    text: `${v.firstName}` + " " + `${v.lastName}`,
                })
            );
        });

    },


};
</script>